<template>
  <div class="title-cover">
    <svg width="1.6rem" height="1.5rem">
      <polyline
              :stroke-width="sw_4"
              fill="transparent"
              :stroke="mergedColor[0]"
              :points="autoExpend(ps_1)"
      />
      <polyline
              :stroke-width="sw_2"
              fill="transparent"
              :stroke="mergedColor[1]"
              :points="autoExpend(ps_2)"
      />
    </svg>
    <slot></slot>
    <svg width="1.6rem" height="1.5rem">
      <polyline
              :stroke-width="sw_4"
              fill="transparent"
              :stroke="mergedColor[0]"
              :points="autoExpend(ps_3)"
      />
      <polyline
              :stroke-width="sw_2"
              fill="transparent"
              :stroke="mergedColor[1]"
              :points="autoExpend(ps_4)"
      />
    </svg>
  </div>
</template>

<script>
  import {deepMerge} from '@jiaminghi/charts/lib/util/index'

  import {deepClone} from '@jiaminghi/c-render/lib/plugin/util'
  import {_pxGenerator} from "../../../../LayoutMaps/maps/MapFunction";

  export default {
    name: 'TitleCover',
    props: {
      color: {
        type: Array,
        default: () => ([])
      }
    },
    data() {
      return {
        defaultColor: ['#1dc1f5', '#1dc1f5'],
        mergedColor: [],
        sw_2: _pxGenerator(0.02),
        sw_4: _pxGenerator(0.05),
        ps_1: [10, 0, 19, 10, 10, 20],
        ps_2: [2, 0, 11, 10, 2, 20],
        ps_3: [11, 0, 2, 10, 11, 20],
        ps_4: [19, 0, 10, 10, 19, 20],
        joinStr: [',', ' ']
      }
    },
    mounted() {
      const {mergeColor} = this
      mergeColor()
    },
    watch: {
      color() {
        const {mergeColor} = this
        mergeColor()
      }
    },
    methods: {
      mergeColor() {
        const {color, defaultColor} = this
        this.mergedColor = deepMerge(deepClone(defaultColor, true), color || [])
      },
      autoExpend(points) {
        let index = 0;
        let result = '';
        for (let val of points) {
          result += _pxGenerator(val / 100) + this.joinStr[index++ % 2];
        }
        return result;
      }
    }
  }
</script>

<style scoped>
  .title-cover {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
</style>
